export function MoonIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.77 2c1.13 0 2.207.16 3.23.46-4.372 1.27-7.539 5.06-7.539 9.54 0 4.48 3.167 8.27 7.539 9.54-1.023.3-2.1.46-3.23.46C8.824 22 4 17.52 4 12S8.825 2 14.77 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
